import React from 'react';

//import SVGCrowbar from '../SVGCrowbar/SVGCrowbar';

import './Controls.css';

const Controls = (props) => {

	const { changeProfession, professions } = props;

	const cleanUp = str => str.replace(' ', '');

	// const { showAdmin, updateShow, changeProfession, professions } = props;
	// const { showAdmin, updateShow, changeProfession, changeLevel, professions, level } = props;
	// const handleClickChange= (event) => changeProfession(event.target.value);
	// const handleClickToggle = (event) => updateShow(event.target.value);
	// const handleClickSave = () => SVGCrowbar(true);
	// const options = professions.map((profession) => <option key={'option-'+profession} value={profession}>{profession}</option>);
 	// const buttonToggleLevel = <button onClick={changeLevel}>{ (level === 'detail' ? 'toon hoofdniveau ' : 'toon detailniveau')}</button>

 	const buttons = professions.map((profession) => (
 		<button
 			key={profession}
 			className={'btn btn-primary ' + cleanUp(profession) }
 			onClick={() => changeProfession(profession)} >
 				{profession}
		</button>));

	return (
			<div className="Controls col-md-6">
				{buttons}
			</div>
		)
}

export default Controls;




// WEBPACK FOOTER //
// ./src/components/Controls/Controls.js